// @ts-ignore
/* eslint-disable */
import { request } from '@umijs/max';

/** 管理员登录接口 POST /admin-api/login */
export async function adminLogin(body: API.AdminLoginParams, options?: { [key: string]: any }) {
  return request<API.AdminLoginResult>('/admin-api/login', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 管理员退出登录接口 POST /admin-api/logout */
export async function adminLogout(options?: { [key: string]: any }) {
  return request<Record<string, any>>('/admin-api/logout', {
    method: 'POST',
    ...(options || {}),
  });
}

/** 获取当前管理员信息 GET /admin-api/getAdminProfile */
export async function getCurrentAdmin(options?: { [key: string]: any }) {
  return request<{
    code: number;
    msg: string;
    data: API.AdminInfo;
  }>('/admin-api/getAdminProfile', {
    method: 'GET',
    ...(options || {}),
  });
}
